import AbstractComponent from "./abstract-component";


const createTemplate = ({title, link, imgSrc, imgSrcMobile}) => {
  return (
    `<a class="banner__link" href="${link}" title="${title}">
      <picture>
        <source media="(max-width: 999px)" srcset="${imgSrcMobile}" width=1000 height=526>
        <source media="(min-width: 1000px)" srcset="${imgSrc}" width=1400 height=353>
        <img class="banner__image" src="${imgSrc}" alt="${title}" width=1400 height=353>
      </picture>
      </a>`
  );
};

// type="image/webp"
// <source srcset="${imgSrc}" media="(min-width: 1000px)" >
// <img class="banner__image" src="${imgSrcMobile}" alt="${title}" width="1400" >
// width="1000" height="526"
// height="353"

export default class BannerComponent extends AbstractComponent {
  constructor({data = ``}) {
    super();

    this._data = data;
  }

  getTemplate() {
    return createTemplate(this._data);
  }
}
